import React from 'react';
import { t } from '@lingui/macro';

import { Text } from '@rover/kibble/core';
import { AvailabilityPreferences } from '@rover/rsdk/src/apiClient/latest/model/availabilityPreferences';

type Props = {
  sitterName: string;
  capacity: AvailabilityPreferences;
  textSize?: '100' | '200';
};

const ServiceCapacity = ({ sitterName, capacity, textSize = '100' }: Props): JSX.Element => {
  const count = capacity.spacesAvailable;

  const spacesAvailableText =
    count === 1 ? capacity.spacesAvailableTextSingular : capacity.spacesAvailableTextPlural;

  const label = spacesAvailableText.toLowerCase();

  return <Text size={textSize}>{t`${sitterName} can host up to ${count} ${label}`}</Text>;
};

export default ServiceCapacity;
